import React from "react";

export const FeedbackDetailsModal = ({
  showFeedbackDetailsModal,
  setShowFeedbackDetailsModal,
  data,
  details,
  isDetailsLoading,
}) => {
  const closeModal = () => {
    setShowFeedbackDetailsModal(false);
  };

  return (
    <>
      {showFeedbackDetailsModal ? (
        <div className={`modal fade d-block show modal-container`}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Feedback Details</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body">
                {/* <p className="text-muted mb-4">
                  {data?.givenDate} {data?.givenTime} &middot; {data?.kiosk}
                </p>
                {data?.name ? (
                  <p className="text-muted mb-2">
                    <strong>Feedback: </strong>
                    {data.name}
                  </p>
                ) : null} */}

                {isDetailsLoading ? (
                  <p className="mb-0">Loading details...</p>
                ) : (
                  <>
                    <div className="mb-4">
                      <p className="mb-1">
                        <strong>{details?.question}</strong>
                      </p>
                      <p className="mb-0" style={{ fontSize: "16px" }}>
                        {data?.image ? `${data.image} ` : ""}
                        {details?.answer}
                      </p>
                    </div>

                    {details?.subQuestion ? (
                      <div
                        className="pl-3"
                        style={{ borderLeft: "3px solid #e0e0e0" }}
                      >
                        <p className="mb-1">
                          <strong>{details.subQuestion}</strong>
                        </p>
                        <p className="mb-0" style={{ fontSize: "16px" }}>
                          {details.subAnswer}
                        </p>
                      </div>
                    ) : null}
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
